import React from 'react';
import styled from 'styled-components';
import NPSLineChart from './nps/NPSLineChart';
import NPSBarChart from './nps/NPSBarChart';
import NPSCategoriesPieChart from './nps/NPSCategoriesPieChart';
import TopicsDistributionPieChart from './nps/TopicsDistributionPieChart';
import NPSImprovementSuggestionsChart from './nps/NPSImprovementSuggestionsChart';
import { MdOutlineUploadFile } from 'react-icons/md';
import DynamicFilterChartComponent from './nps/DynamicFilterChartComponent';
import { Col, Row } from 'reactstrap';

const Section = styled.section`
  padding: 50px;
`;

const Title = styled.h2`
  color: #333;
  text-align: center;
`;

const SmallTitle = styled.h2`
  color: #333;
  text-align: center;
  font-size: 15px;
  font-weight: bold;
  margin: 0;
`;
const Description = styled.p`
  color: #666;
  text-align: center;
  margin-top: 20px;
`;

const ContentArea = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 40px;
`;

const ChartWrapper = styled.div`
  display: flex;
  justify-content: center;

  width: 100%; // Ensure the wrapper takes up all available width
`;

const CTAButton = styled.button`
  display: block; // Ensure button is a block element for easy centering
  margin: 20px auto; // Auto margins for horizontal centering
  color: white;
  background-color: #007bff; // Bootstrap primary color for consistency
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;

  &:hover {
    background-color: #0056b3;
  }
`;

const NPSSurveyAnalysis = () => {
  return (
    <Section>
      <Title>Improve Your NPS Score</Title>
      <Description>Discover how our tool helps you analyze and elevate your NPS score effectively.</Description>
      <ContentArea>

        <Col xs={12}>

          <Row><MdOutlineUploadFile size='2em' style={{ position: 'relative', top: '-10px' }} />

            <SmallTitle style={{ marginLeft: '10px' }}>Upload survey data - Get immediate action items with Impact
              (Segmented to specific customers)</SmallTitle>
          </Row>
          <ChartWrapper>
            <NPSImprovementSuggestionsChart />
          </ChartWrapper>

          <Row className='justify-content-md-center' style={{ marginTop: '50px' }}>
            <Col >
              <SmallTitle>Explore different statistics</SmallTitle>
              <ChartWrapper>
                <NPSCategoriesPieChart />
              </ChartWrapper>
            </Col>


            <Col>
              <SmallTitle>Topics detected by AI</SmallTitle>
              <ChartWrapper>
                <TopicsDistributionPieChart />
              </ChartWrapper>
            </Col>
          </Row>

          <Row className='justify-content-md-center' style={{ marginTop: '50px' }}>
            <Col lg='8'>
              <SmallTitle>Monitor Success - NPS Improvement Over Time (Example)</SmallTitle>
              <ChartWrapper>
                <NPSLineChart />
              </ChartWrapper>
            </Col>
          </Row>

          <Row className='justify-content-md-center' style={{ marginTop: '50px' }}>
            <Col lg='8'>
              <SmallTitle>Before and After NPS Improvement</SmallTitle>
              <ChartWrapper>
                <NPSBarChart />
              </ChartWrapper>
            </Col>
          </Row>

          <Row className='justify-content-md-center' style={{ marginTop: '50px' }}>
            <Col lg='8'>
              <SmallTitle>Customize Analyses with self-defined topics and other filters</SmallTitle>
              <ChartWrapper>
                <DynamicFilterChartComponent />
              </ChartWrapper>
            </Col>
          </Row>
        </Col>
      </ContentArea>

    </Section>
  );
};

export default NPSSurveyAnalysis;